export default __webpack_public_path__ + "static/media/control-3.35833c7e.svg";